import React from 'react'
import Navbar from './Navbar'
import MoreImages from './MoreImages'
import Footer from './Footer'

const MoreGlassImages = () => {
  return (
    <div>
      {/* <Navbar /> */}
      <MoreImages />
      {/* <Footer /> */}
    </div>
  )
}

export default MoreGlassImages
